import { useState, useEffect } from "react";

import { useTranslation } from 'react-i18next';
const COUNTDOWN_KEY = "pricing-countdown-start";
const COUNTDOWN_DAYS = 7;

function getRemainingMs() {
  let startTime;
  try {
    startTime = localStorage.getItem(COUNTDOWN_KEY);
  } catch {
    startTime = null;
  }

  if (!startTime) {
    const now = Date.now();
    try {
      localStorage.setItem(COUNTDOWN_KEY, String(now));
    } catch {
      // localStorage unavailable
    }
    startTime = now;
  } else {
    startTime = Number(startTime);
  }

  const elapsed = Date.now() - startTime;
  const totalMs = COUNTDOWN_DAYS * 24 * 60 * 60 * 1000;
  return Math.max(0, totalMs - elapsed);
}

function formatCountdown(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${days}d ${String(hours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}m ${String(seconds).padStart(2, "0")}s`;
}

export default function CountdownTimer() {
  const { t } = useTranslation();
  const [remaining, setRemaining] = useState(getRemainingMs);

  useEffect(() => {
    const id = setInterval(() => {
      const ms = getRemainingMs();
      setRemaining(ms);
      if (ms <= 0) clearInterval(id);
    }, 1000);
    return () => clearInterval(id);
  }, []);

  const expired = remaining <= 0;

  return (
    <div className="text-center mb-8" role="timer" aria-live="polite" aria-label={expired ? "Founding pricing ended" : "Countdown to founding member pricing expiration"}>
      {expired ? (
        <p className="font-mono text-xs uppercase tracking-wider text-zinc-500">{t('countdown_timer.founding_pricing_ended_current_pricing_below')}</p>
      ) : (
        <p className="font-mono text-xs uppercase tracking-wider text-amber-500/80">
          <span aria-hidden="true" className="mr-1">⏰</span>
          Limited Time Offer:{" "}
          <span className="font-bold text-amber-500">{formatCountdown(remaining)}</span>{" "}
          remaining for founding member pricing
        </p>
      )}
    </div>
  );
}
